import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import axios from "axios";
import storage from "redux-persist/lib/storage";
import jwtDecode from "jwt-decode";
import Swal from 'sweetalert2'
import Cookies from "universal-cookie";
import { SERVERURL } from "../ServerUrl";
const cookies = new Cookies();

const initialStateFunction = () => ({

  allVehiclesData:[],
  getAllDriversData:[],
  getCustomersData:[],
  getAllBookingsData:[],

});
//add Vehicle
export const addVehicle = createAsyncThunk("addVehicle", async ({data,vehicleData}) => {
  // console.log("check", detail);
  let Array=[...vehicleData];
  try {
    const data1 = await axios.post(
      `${SERVERURL}/addVehicle`,
      
      data
    );

    console.log("DataResDataRes", data1.data);
    Array.push(data1.data.vehicleNew);
    Swal.fire(
      'Good',
      data1.data.message,
      'success'
    )
    return Array;
  } catch (err) {
    console.log("NoLoginError", err?.response?.data?.message);
  }
});
//get Vehicle
export const getAllVehicles = createAsyncThunk(
  "getAllVehicles",
  async (detail) => {
    console.log("check", detail);
    try {
      const data = await axios.get(
        `${SERVERURL}/getVehicles`
      );

      console.log("DataRes", data.data);
      return data.data.vehicles;
    } catch (err) {
      console.log("NoLoginError", err?.response?.data?.message);
    }
  }
);
//Delete Vehicle
export const deleteVehicle = createAsyncThunk(

  "deleteVehicle",
  async ({id,vehicleData}) => {
    let Array=[...vehicleData];
    console.log("checkId", id);
    try {
      const data = await axios.delete(
        `${SERVERURL}/deleteVehicle/${id}`
      );
      let index = 0;
      vehicleData.map((item, i) => {
        if (item._id === id) {
          index = i;
          console.log("indexResult", index);
        }
  
      });
  
    
      Array.splice(index, 1);

      console.log("DataRes", data.data);
      Swal.fire(
      
        data?.data?.message,
        'success'
      )
      return Array;
    } catch (err) {
      console.log("NoLoginError", err?.response?.data?.message);
    }
  }
);
//update Vehicle
export const updateVehicle = createAsyncThunk("updateVehicle", async ({id,data,vehicleData}) => {
  // console.log("check", detail);
  let Array=[...vehicleData];
  try {
    console.log("ArrayUpdateBefore",Array);
    const data1 = await axios.put(
      `${SERVERURL}/updateVehicle/${id}`,
      data
    );

    console.log("data1Update",data1?.data?.data._id);
    console.log("data1Update",data1?.data?.data);
    console.log("ArrayUpdate",Array);

    let index = 0;
    vehicleData?.map((item, i) => {
      if (item?._id === data1?.data?.data?._id) {
        index = i;
        console.log("indexResult", index);
      }
    });
    console.log("DataResDataRes",data1?.data?.data?._id);
    console.log("DataResDataRes",data1?.data);


        Array.splice(index, 1,data1?.data?.data);
        console.log("ArrayUpdateAfterSplice",Array);
        Swal.fire(
          'Good',
          data1?.data?.message,
          'success'
        )
    return Array;
  } catch (err) {
    console.log("NoLoginError", err?.response?.data?.message);
  }
});
//add Driver
export const addDriver = createAsyncThunk("addDriver", async ({vehicle,driversData}) => {
  // console.log("check", detail);
  let Array=[...driversData];
  try {
    const data1 = await axios.post(
      `${SERVERURL}/addDriver`,
      vehicle
    );

    console.log("DataResDataRes", data1.data);
    Array.push(data1.data.newDriver);
    Swal.fire(
      'Good',
      data1.data.message,
      'success'
    )
    return Array;
  } catch (err) {
    console.log("NoLoginError", err?.response?.data?.message);
  }
});

//edit customer
export const editCustomerAdmin = createAsyncThunk("editCustomerAdmin", async ({id,vehicle,getCustomersData}) => {

let Array=[...getCustomersData]

    try {
      const data1 = await axios.put(
        `${SERVERURL}/editProfile/${id}`,
        
        vehicle
      );
  
        
    console.log("getCustomersData",data1.data.data)
      let index = 0;
      getCustomersData?.map((item, i) => {
        if (item?._id === data1?.data?.data?._id) {
          index = i;
          console.log("indexResult", index);
        }
      });

  
  
          Array.splice(index, 1,data1?.data?.data);
          console.log("ArrayUpdateAfterSplice",Array);
          Swal.fire(
            'Good',
            data1?.data?.message,
            'success'
          )
      return Array;
    } catch (err) {
      console.log("NoLoginError", err?.response?.data?.message);
    }
  });


//get Vehicle
export const getAllDrivers = createAsyncThunk(
  "getAllDrivers",
  async (detail) => {
    console.log("check", detail);
    try {
      const data = await axios.get(
        `${SERVERURL}/getDrivers`
      );

      console.log("DataRes", data.data);
      return data.data.drivers;
    } catch (err) {
      console.log("NoLoginError", err?.response?.data?.message);
    }
  }
);

//Delete Driver
export const deleteDriver = createAsyncThunk(

  "deleteDriver",
  async ({id,driversData}) => {
    let Array=[...driversData];
    console.log("checkId", id);
    try {
      const data = await axios.delete(
        `${SERVERURL}/deleteDriver/${id}`
      );
      let index = 0;
      driversData.map((item, i) => {
        if (item._id === id) {
          index = i;
          console.log("indexResult", index);
        }
  
      });
  
    
      Array.splice(index, 1);

      console.log("DataRes", data.data);
      Swal.fire(
      
        data?.data?.message,
        'success'
      )
      return Array;
    } catch (err) {
      console.log("NoLoginError", err?.response?.data?.message);
    }
  }
);

//Delete Customer
export const deleteCustomer = createAsyncThunk(

  "deleteCustomer",
  async ({id,customerData}) => {
    let Array=[...customerData];
    console.log("checkId", id);
    try {
      const data = await axios.delete(
        `${SERVERURL}/deleteCustomer/${id}`
      );
      let index = 0;
      customerData.map((item, i) => {
        if (item._id === id) {
          index = i;
          console.log("indexResult", index);
        }
  
      });
  
    
      Array.splice(index, 1);

      console.log("deleteCustomerDataRes", data.data);
      Swal.fire(
      
        data?.data?.message,
        'success'
      )
      return Array;
    } catch (err) {
      console.log("NoLoginError", err?.response?.data?.message);
    }
  }
);

//update Vehicle
export const updateDriver = createAsyncThunk("updateDriver", async ({id,vehicle,driversData}) => {
  // console.log("check", detail);
  let Array=[...driversData];
  try {
    console.log("ArrayUpdateBefore",Array);
    const data1 = await axios.put(
      `${SERVERURL}/updateDriver/${id}`,
      vehicle
    );

    console.log("data1Update",data1?.data?.data._id);
    console.log("data1Update",data1?.data?.data);
    console.log("ArrayUpdate",Array);

    let index = 0;
    driversData?.map((item, i) => {
      if (item?._id === data1?.data?.data?._id) {
        index = i;
        console.log("indexResult", index);
      }
    });
    console.log("DataResDataRes",data1?.data?.data?._id);
    console.log("DataResDataRes",data1?.data);


        Array.splice(index, 1,data1?.data?.data);
        console.log("ArrayUpdateAfterSplice",Array);
        Swal.fire(
          'Good',
          data1?.data?.message,
          'success'
        )
    return Array;
  } catch (err) {
    console.log("NoLoginError", err?.response?.data?.message);
  }
});

//get Customers
export const getCustomers = createAsyncThunk(
  "getCustomers",
  async (detail) => {
    console.log("check", detail);
    try {
      const data = await axios.get(
        `${SERVERURL}/getCustomers`
      );

      console.log("DataRes", data.data);
      return data.data.customers;
    } catch (err) {
      console.log("NoLoginError", err?.response?.data?.message);
    }
  }
);


//update prcing
export const pricingUpdation = createAsyncThunk("pricingUpdation", async (data) => {
  // console.log("check", detail);
  // let Array=[...driversData];
  try {
    // console.log("ArrayUpdateBefore",Array);
    const data1 = await axios.put(
      `${SERVERURL}/pricing/63ab43f7469d5c27d0545874`,
      data
    );

    console.log("data1",data1.data.message);

    Swal.fire(
      
      data1.data.message,
      'success'
    )
    return data1;
  } catch (err) {
    console.log("NoLoginError", err?.response?.data?.message);
  }
});

//get Customers
export const getAllBookings = createAsyncThunk(
  "getAllBookings",
  async (detail) => {
    console.log("check", detail);
    try {
      const data = await axios.get(
        `${SERVERURL}/getBookings`
      );

      console.log("DataRes", data.data);
      return data.data.bookings;
    } catch (err) {
      console.log("NoLoginError", err?.response?.data?.message);
    }
  }
);

//login admin
export const loginAdmin = createAsyncThunk("loginAdmin", async (data) => {

  try {
    const data1 = await axios.post(
      `${SERVERURL}/loginAdmin`,
      
      data
    );

    console.log("DataResDataRes", data1.data);

    console.log("DataResDataRes", data1.data);
    cookies.set('_id', data1?.data?.user?._id, { path: '/' });

    cookies.set("userType",data1?.data?.user?.userType,{ path: '/' });
    cookies.set("token",data1?.data?.token,{ path: '/' });


   
    return data1.data;
  } catch (err) {

    console.log("NoLoginError", err?.response?.data?.message);
    return err;
  }
});

export const AdminReducer = createSlice({
  name: "AdminReducer",
  initialState: initialStateFunction(),
  reducers: {
    setCurrentUser(state, action) {
      state.currentUser = action.payload;
    },

    resetState: (state) => initialStateFunction(),
  },
  extraReducers: {
    [getAllVehicles.fulfilled]: (state, action) => {
      state.allVehiclesData = action.payload;
    },
    [addVehicle.fulfilled]: (state, action) => {
      if(action.payload != undefined)
      {
      state.allVehiclesData = action.payload;
      }
    },
    [deleteVehicle.fulfilled]: (state, action) => {
      if(action.payload != undefined)
      {
      state.allVehiclesData = action.payload;
      }
    },
    [updateVehicle.fulfilled]: (state, action) => {
      if(action.payload != undefined)
      {
      state.allVehiclesData = action.payload;
      }
    },
    [getAllDrivers.fulfilled]: (state, action) => {
      if(action.payload != undefined)
      {
      state.getAllDriversData = action.payload;
      }
    },
    [addDriver.fulfilled]: (state, action) => {
      if(action.payload != undefined)
      {
      state.getAllDriversData = action.payload;
      }
    },
    [deleteDriver.fulfilled]: (state, action) => {
      if(action.payload != undefined)
      {
      state.getAllDriversData = action.payload;
      }
    },
    [updateDriver.fulfilled]: (state, action) => {
      if(action.payload != undefined)
      {
      state.getAllDriversData = action.payload;
      }
    },
    [getCustomers.fulfilled]: (state, action) => {
      if(action.payload != undefined)
      {
      state.getCustomersData = action.payload;
      }
    },
    [editCustomerAdmin.fulfilled]: (state, action) => {
      if(action.payload != undefined)
      {
      state.getCustomersData = action.payload;
      }
    },
    [deleteCustomer.fulfilled]: (state, action) => {
      if(action.payload != undefined)
      {
      state.getCustomersData = action.payload;
      }
    },
    [getAllBookings.fulfilled]: (state, action) => {
      if(action.payload != undefined)
      {
      state.getAllBookingsData = action.payload;
      }
    },
  },
});



const persistConfig = {
  key: "root",
  storage,
  whitelist: ["AdminReducer"],
};

const user = AdminReducer.reducer;

// Action creators are generated for each case reducer function
export const { setCurrentUser } = AdminReducer.actions;
export default persistReducer(persistConfig, user);
